import { CookieUtils } from './cookies/cookie-utils';

onDomReady(function() {
   $$('.close-callout').each(function(el) {
      var parent = el.getParent('.page-callout'),
         calloutCookieName = parent.get('data-callout'),
         calloutLink = parent.get('data-callout-link') || false,
         cookieVal = Cookie.read(calloutCookieName);

      if (cookieVal !== 'closed') {
         parent.show();

         el.addEvent('click', function(ev) {
            parent.hide();
            // Don't let this click get to the link
            ev.stop();
            CookieUtils.set(calloutCookieName, 'closed', {
               maxAgeInSeconds: 31536000, // 1 year
            });
         });
      }
   });
});
